import React from 'react';
import type { SvgIconProps } from '@mui/material';
import {
  ShoppingBag as CarryoutIcon,
  LocalShipping as DeliveryIcon,
  Restaurant as DineInIcon,
  DriveEta as DriveThruIcon,
  Celebration as CateringIcon,
  Schedule as FallbackIcon,
} from '@mui/icons-material';
import type { OccasionType } from './types';

/**
 * Single source of truth for the MUI icon that represents each occasion.
 * Emoji equivalents for plain-text contexts live in OCCASION_ICONS (types.ts).
 */
export const OCCASION_ICON_COMPONENTS: Record<OccasionType, React.ElementType<SvgIconProps>> = {
  CARRYOUT: CarryoutIcon,
  DELIVERY: DeliveryIcon,
  DINE_IN: DineInIcon,
  DRIVE_THRU: DriveThruIcon,
  CATERING_CARRYOUT: CateringIcon,
};

interface OccasionIconProps extends SvgIconProps {
  occasion: string;
}

/**
 * Renders the icon for an occasion code. Unknown codes fall back to a clock so
 * a new Byte Graph occasion never crashes a chip or tab.
 */
export const OccasionIcon: React.FC<OccasionIconProps> = ({ occasion, ...iconProps }) => {
  const Icon = OCCASION_ICON_COMPONENTS[occasion.toUpperCase() as OccasionType] ?? FallbackIcon;
  return <Icon {...iconProps} />;
};
